import React, { useState, useEffect } from 'react'
import { useHistory, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import to from 'await-catch'
import { Formik } from 'formik'
import * as yup from 'yup'
import {
	FormHeader,
	FormTitle,
	ClinicLogoContainer,
	ClinicLogo,
	InputsContainer,
	ButtonsContainer,
	SecondaryButtonsContainer,
	FooterText,
	FormContainer
} from '../../ui/form'
import Input from '../../ui/input'
import { Button } from '../../ui/button'
import ClinicaSantaIsabel from '../../../assets/icons/clinicas/ClinicaSantaIsabel.svg'
import ClinicaBazterrica from '../../../assets/icons/clinicas/ClinicaBazterrica.svg'
import ClinicaDelSol from '../../../assets/icons/clinicas/ClinicaDelSol.svg'
import CentroMedicoBazterica from '../../../assets/icons/clinicas/CentroMedicoBazterica.svg'
import CentroMedicoSantaRita from '../../../assets/icons/clinicas/CentroMedicoSantaRita.svg'
import CentroMedicoSantaIsabel from '../../../assets/icons/clinicas/CentroMedicoSantaIsabel.svg'
import { ChevronRight } from '../../../assets/icons'
import { login as loginAction, setPatientDetails } from '../../../actions'
import { login, getPatientDataAtClinic } from '../../../api'
import envConfig from '../../../config'
import features from '../../../features'
import { DISABLED_FEATURE_MESSAGE } from '../../../constants'
import { PATIENT_GROUP } from '../../../constants'
import { Divider, LinkButtonFrontPage } from '../../ui/form/styled'

const LoginForm = ({ auth, loginAction, setPatientDetails }) => {
	const history = useHistory()
	const [isLoggedIn, setIsLoggedIn] = useState(false)

	const checkLoggedInUser = () => {
		if (Object.keys(auth).length) {
			setIsLoggedIn(true)
		}
	}
	useEffect(() => {
		if (Object.keys(auth).length) setIsLoggedIn(true)
	}, [auth])

	const initialValues = { email: '', password: '' }
	const validationSchema = yup.object().shape({
		email: yup
			.string()
			.email('Email no válido')
			.required('Campo requerido'),
		password: yup.string().required('Campo requerido')
	})

	const loadPatientDetails = async authData => {
		const [err, { data } = {}] = await to(getPatientDataAtClinic(0))
		const doc = authData?.metadatos?.find(metadata => metadata.metadato.clave == 'NroDoc')
		const phone = authData?.metadatos?.filter(metadata => metadata.metadato.clave == 'Telefono')
		const patientERID = authData?.metadatos?.find(
			metadata => metadata.metadato.clave === 'PacienteERID'
		)?.valor
		const erid =
			authData?.metadatos?.find(metadata => metadata.metadato.clave === 'ERID')?.valor || null
		setPatientDetails({
			...data,
			numeroDocumento: doc ? doc.valor : null,
			telefono: phone.length ? phone[0].valor : data.telefono,
			pacienteErid: patientERID,
			erid
		})
	}

	const handleSubmit = async (values, { setSubmitting, setErrors }) => {
		const [err, { data } = {}] = await to(login(values))
		if (!err) {
			loginAction(data)
			if (data.roles.some(value => value === PATIENT_GROUP)) {
				await loadPatientDetails(data)
			}
			setSubmitting(false)
			checkLoggedInUser()
		} else {
			setErrors({ general: 'Error al iniciar sesión. Verifica tus credenciales.' })
			setSubmitting(false)
		}
	}

	const handleCreateAccount = () => {
		history.push('/registro')
	}

	const handleForgotPassword = () => {
		history.push('/recuperar-cuenta')
	}

	if (isLoggedIn) {
		return <Redirect to="/inicio" />
	}

	return (
		<FormContainer paddingMobile={'32px 15px'} justifyMobile="start" margin={"auto auto 0 auto"}>
			<FormHeader align="center" gap={16} mb={32}>
				<FormTitle>Mi Portal Clínicas</FormTitle>
				<ClinicLogoContainer gap={8}>
					<ClinicLogo src={ClinicaSantaIsabel} alt="Clínica Santa Isabel" />
					<ClinicLogo src={ClinicaDelSol} alt="Clínica del Sol" />
					<ClinicLogo src={ClinicaBazterrica} alt="Clínica Bazterrica" />
					<ClinicLogo src={CentroMedicoBazterica} alt="Centro Médico Bazterrica" />
					<ClinicLogo src={CentroMedicoSantaRita} alt="Centro Médico Santa Rita" />
					<ClinicLogo src={CentroMedicoSantaIsabel} alt="Centro Médico Santa Isabel" />
				</ClinicLogoContainer>
			</FormHeader>
			<Formik
				initialValues={initialValues}
				validationSchema={validationSchema}
				onSubmit={handleSubmit}
			>
				{({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
					<form onSubmit={handleSubmit} style={{ width: '100%' }}>
						<InputsContainer gap={24} mb={16} height="auto">
							<Input
								label="Email"
								type="email"
								name="email"
								placeholder="Ingresá tu email"
								value={values.email}
								onChange={handleChange}
								onBlur={handleBlur}
								error={touched.email && errors.email}
								fullWidth />
							<Input
								label="Contraseña"
								type="password"
								name="password"
								placeholder="Ingresá tu contraseña"
								value={values.password}
								onChange={handleChange}
								onBlur={handleBlur}
								error={touched.password && errors.password}
								fullWidth
								isPassword
							/>
						</InputsContainer>
						<ButtonsContainer gap={0}>
							<LinkButtonFrontPage type="button" onClick={handleForgotPassword} mb={24}>
								Olvidé mi contraseña
							</LinkButtonFrontPage>
							<Button
								label="Ingresar"
								$variant="primary"
								size="mobile"
								type="submit"
								disabled={!values.email || !values.password}
							/>
						</ButtonsContainer>
					</form>
				)}
			</Formik>
			<Divider color={"#E0E0E0"} margin={'15px'} />
			<SecondaryButtonsContainer gap={16} mb={24}>
				<Button
					size="card"
					$variant="cardNav"
					onClick={() => window.open(envConfig.endpoints.GUARDIA_URL, '_blank')}
					label={features.disableClinicGuard ? DISABLED_FEATURE_MESSAGE : 'Ir a la guardia'}
					iconRight={<ChevronRight />}
					disabled={features.disableClinicGuard}
					padding={'18px'}
					height={'auto'}
				/>
				<Button
					size="card"
					$variant="cardNav"
					onClick={() => window.open(envConfig.endpoints.TURNERA_URL, '_blank')}
					label="Pedir turno"
					iconRight={<ChevronRight />}
					padding={'18px'}
					height={'auto'}
				/>
			</SecondaryButtonsContainer>
			<FooterText>
				¿No tenés una cuenta?{' '}
				<LinkButtonFrontPage type="button" onClick={handleCreateAccount}>
					Crea tu cuenta ahora
				</LinkButtonFrontPage>
			</FooterText>
		</FormContainer>
	)
}

const mapStateToProps = ({ auth }) => {
	return { auth }
}

const mapDispatchToProps = {
	loginAction,
	setPatientDetails
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)
